import {
    AbstractRestrictionsService,
    RESTRICTION_ACTIVITY,
    RESTRICTION_AGGREGATE_TABLE,
    RESTRICTION_FEATURE_LAYERS,
    RESTRICTION_HEATMAP,
    RESTRICTION_IMAGERY_LAYERS,
    RESTRICTION_IP_DEVICE,
    RESTRICTION_LOGICAL_VIEWS,
    RESTRICTION_MAP_LAYERS,
    RESTRICTION_PATH_PROFILING,
    RESTRICTION_QUERY_TAB,
    RESTRICTION_REPORTS,
    RESTRICTION_RF_PLANNING,
    RESTRICTION_STAT_BROWSER,
    RESTRICTION_TERRAIN,
    RESTRICTION_TICKETS,
    RESTRICTION_TRIGGERS,
    RESTRICTION_ZONES,
    RestrictionsServiceState,
} from 'app/licensing/restriction_service_interface';
import { CachedEventRegistry } from 'app/shared/events/cached_event_registry';

export class AgricultureRestrictionsService implements AbstractRestrictionsService {
    private _eventRegistry: CachedEventRegistry<[RestrictionsServiceState?]>;

    constructor() {
        const state: RestrictionsServiceState = {
            [RESTRICTION_RF_PLANNING]: null,
            [RESTRICTION_PATH_PROFILING]: null,
            [RESTRICTION_HEATMAP]: null,
            [RESTRICTION_ZONES]: null,
            [RESTRICTION_TERRAIN]: true,
            [RESTRICTION_IMAGERY_LAYERS]: null,
            [RESTRICTION_FEATURE_LAYERS]: null,
            [RESTRICTION_ACTIVITY]: true,
            [RESTRICTION_MAP_LAYERS]: true,
            [RESTRICTION_REPORTS]: null,
            [RESTRICTION_STAT_BROWSER]: true,
            [RESTRICTION_TICKETS]: null,
            [RESTRICTION_TRIGGERS]: null,
            [RESTRICTION_QUERY_TAB]: null,
            [RESTRICTION_LOGICAL_VIEWS]: null,
            [RESTRICTION_IP_DEVICE]: null,
            [RESTRICTION_AGGREGATE_TABLE]: null,
        };
        this._eventRegistry = new CachedEventRegistry(state);
    }

    subscribeToChanges(fn: (restrictions: Readonly<RestrictionsServiceState>) => void): () => void {
        return this._eventRegistry.addEventListener(fn);
    }
}
